__turbopack_context__.v({
  "container": "EspwoG_container",
  "footer": "EspwoG_footer",
  "message": "EspwoG_message",
  "title": "EspwoG_title",
});
